jQuery('.hamburger').click(function(){

 jQuery('.cbp-spmenu-right').toggleClass('activeMenu');

});